/**
 * Logic for the affixed (frozen) column configuration of a table.
 */

/**
 * Whether the table has any user-frozen columns.
 *
 * This is deliberately narrower than `TableUtil.getAffixedColumnCount()`, which also counts the
 * adapter-supplied `defaultAffixedColumnCount`. Only user-frozen columns get the "last frozen
 * column" divider, so an adapter default that affixes columns does not make this true.
 */
export function computeHasAnyFrozenColumns(frozenColumnCount: number | null | undefined): boolean {
  return (frozenColumnCount ?? 0) > 0;
}
